<template>
  <div>
    <template v-if="data != null">
      <template v-if="account.user.roles[0] == 'EC_USER'">
        <v-row>
          <v-col>
            <h4>{{ $t("calibration.noaccess") }}</h4>
          </v-col>
        </v-row>
      </template>

      <v-row>
        <v-col cols="2" v-for="(item, index) in data.units" :key="index">
          <v-checkbox v-model="checkboxes" :label="item.name" color="primary" :value="item.address" hide-details> </v-checkbox>
        </v-col>
      </v-row>

      <v-row class="justify-space-around">
        <v-col cols="12" md="4">
          <CommandDialog :command="'setdefault' + this.commandParameters" type="calibration" buttonColor="red" :cardTitle="$t('calibration.setdefaultconfiguration')" :cardText="$t('calibration.defaultconfigurationareyousure')" :actionYes="$t('calibration.yes')" :actionNo="$t('calibration.no')" />
        </v-col>
        <v-col cols="12" md="4">
          <CommandDialog :command="'save' + this.commandParameters" type="calibration" buttonColor="red" :cardTitle="$t('calibration.saveconfiguration')" :cardText="$t('calibration.saveconfigurationareyousure')" :actionYes="$t('calibration.yes')" :actionNo="$t('calibration.no')" />
        </v-col>
        <v-col cols="12" md="4">
          <CommandDialog
            :command="'offsetsautocalibration' + this.commandParameters"
            type="calibration"
            buttonColor="red"
            :cardTitle="$t('calibration.offsetsautocalibration')"
            :cardText="$t('calibration.offsetsautocalibrationareyousure')"
            :actionYes="$t('calibration.yes')"
            :actionNo="$t('calibration.no')"
          />
        </v-col>
      </v-row>

      <v-row dense class="ma-2">
        <v-col>
          <v-select single-line large v-model="selectedUnits" :items="units" :label="$t('calibration.chooseUnit')" multiple clearable color="accent"> </v-select>
        </v-col>
      </v-row>

      <v-row no-gutters class="text-center ma-4">
        <v-col cols="12" md="6">
          <template v-if="filterArray(itemsHead) != 0">
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-row no-gutters class="ma-4">
                  <v-col cols="6" class="subtitle-2">{{ $t("calibration.variable") }} </v-col>
                  <v-col cols="3" class="subtitle-2">{{ $t("calibration.real") }}</v-col>
                  <v-col cols="3" class="subtitle-2">{{ $t("calibration.measured") }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <v-row no-gutters v-for="(items, i) in filterArray(itemsHead)" :key="i">
            <v-col cols="12" sm="4">
              <b class="ma-4"> {{ items.name }} </b>
            </v-col>
            <v-col cols="12" sm="8">
              <v-row no-gutters v-for="(item, j) in items.values" :key="j">
                <v-col cols="6"> {{ $t("calibration.codes." + item.name) }}: </v-col>
                <v-col cols="3"> {{ item.value }} {{ "unit" in item ? item.unit : "" }} </v-col>
                <v-col cols="3">
                  <v-text-field :disabled="account.user.roles[0] == 'EC_USER'" dense v-model="dataSetter[i][j]" @change="sendValue(items.address, item.name, dataSetter[i][j])"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <template v-if="filterArray(itemsTail) != 0">
            <v-row no-gutters class="d-sm-none d-md-flex">
              <v-col cols="12" sm="8" offset-sm="4">
                <v-row no-gutters class="ma-4">
                  <v-col cols="6" class="subtitle-2">{{ $t("calibration.variable") }} </v-col>
                  <v-col cols="3" class="subtitle-2">{{ $t("calibration.real") }}</v-col>
                  <v-col cols="3" class="subtitle-2">{{ $t("calibration.measured") }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <v-row no-gutters v-for="(items, i) in filterArray(itemsTail)" :key="i">
            <v-col cols="12" sm="4">
              <b class="ma-4"> {{ items.name }} </b>
            </v-col>
            <v-col cols="12" sm="8">
              <v-row no-gutters v-for="(item, j) in items.values" :key="j">
                <v-col cols="6"> {{ $t("calibration.codes." + item.name) }}: </v-col>
                <v-col cols="3"> {{ item.value }} {{ "unit" in item ? item.unit : "" }} </v-col>
                <v-col cols="3">
                  <v-text-field :disabled="account.user.roles[0] == 'EC_USER'" dense v-model="dataSetter[i][j]" @change="sendValue(items.address, item.name, dataSetter[i][j])"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";
import { mapState } from "vuex";
import LoadingData from "../../components/LoadingData.vue";

import CommandDialog from "../../components/dialog/CommandDialog.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "CalibrationNew",
  components: {
    CommandDialog,
    LoadingData,
    UpgradeCore,
  },
  data() {
    return {
      timer: null,
      mobile: false,

      load: false,

      user: JSON.parse(sessionStorage.getItem("user")),

      checkboxes: [],
      commandParameters: "",

      selectedUnits: null,
      units: null,

      data: null,
      dataSetter: null,

      value: 0,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.getData();
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    itemsHead() {
      return this.data.units ? this.data.units.slice(0, Math.round(this.data.units.length / 2)) : [];
    },
    itemsTail() {
      return this.data.units ? this.data.units.slice(Math.round(this.data.units.length / 2)) : [];
    },
  },
  methods: {
    filterArray(array) {
      if (this.selectedUnits == null || this.selectedUnits == []) {
        return 0;
      }

      let newArray = [];

      for (let index = 0; index < array.length; index++) {
        if (this.selectedUnits.includes(array[index].name)) {
          newArray.push(array[index]);
        }
      }

      return newArray;
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 1000);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("calibration"), null, null, "GET")
        .then((data) => {
          this.data = data;

          this.units = [];

          for (let index = 0; index < this.data.units.length; index++) {
            this.units.push(this.data.units[index].name);
          }

          if (this.dataSetter == null) {
            this.dataSetter = this.data.units;
          }

          if (this.load === false) {
            this.load = true;
            this.selectedUnits = this.units;
          }
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    sendValue(address, variable, value) {
      if (isNaN(value)) {
        return;
      }

      let parameters = "?" + "cmd" + "=" + "gaincalibration" + "&" + "unit" + "=" + address + "&" + "name" + "=" + variable + "&" + "value" + "=" + value;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("calibration"), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    checkboxes: function () {
      this.commandParameters = "&units=" + this.checkboxes.join(",");
    },
  },
};
</script>

<style scoped></style>
